import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function ArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 17">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1476 0.318508L21.0681 7.23903C21.4928 7.6637 21.4928 8.35224 21.0681 8.77692L14.1476 15.6974C13.7229 16.1221 13.0344 16.1221 12.6097 15.6974C12.185 15.2728 12.185 14.5842 12.6097 14.1595L17.6738 9.09543H1.08745C0.48687 9.09543 0 8.60856 0 8.00797C0 7.40739 0.486867 6.92052 1.08745 6.92052H17.6738L12.6097 1.8564C12.185 1.43172 12.185 0.743186 12.6097 0.318508C13.0344 -0.106169 13.7229 -0.106169 14.1476 0.318508Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
